import { Dispatch, SetStateAction } from 'react';
import { OrderTransaction, Pagination, Transaction } from 'interfaces';
import { API } from 'data/30pay.api';
import { get } from 'scripts';

export const getOrderTransactions = async (
    setLoading: Dispatch<SetStateAction<boolean>>,
    setData: Dispatch<SetStateAction<Pagination<OrderTransaction> | undefined>>,
    page: number,
    pageSize: number,
    query?: string,
) => {
    setLoading(true);
    await get<Pagination<OrderTransaction>>(`${API.orderTransaction.getMine}/${page}/${pageSize}${query ? query : ''}`)
        .then((response) => {
            setData(response.value.value);
        })
        .catch((error) => console.error(error))
        .finally(() => setLoading(false));
};

export const getTransactions = async (
    setLoading: Dispatch<SetStateAction<boolean>>,
    setData: Dispatch<SetStateAction<Pagination<Transaction> | undefined>>,
    page: number,
    pageSize: number,
    query?: string,
) => {
    setLoading(true);
    await get<Pagination<Transaction>>(`${API.transaction.mine}/${page}/${pageSize}${query ? query : ''}`)
        .then((response) => {
            setData(response.value.value);
        })
        .catch((error) => console.error(error))
        .finally(() => setLoading(false));
};

